import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { zoneList } from '@blade-sxp/task-management/api/statistics/index';
let tableHeader = class tableHeader extends Vue {
    props = {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false,
    };
    value = '';
    filterArea = [];
    mounted() {
        this.getzoneList();
    }
    // 处理地区树数据结构
    dealAreaTree(tree) {
        const newTree = tree.map((i) => {
            let children = i.children;
            if ((children && children.length === 0) || !children) {
                delete i.children;
            }
            else {
                this.dealAreaTree(children);
            }
            return i;
        });
        return newTree;
    }
    nodeClick(data) {
        let idArr = this.$refs.tree.getCheckedKeys();
        this.$emit('nodeClick', idArr);
    }
    getzoneList() {
        let param = {
            externalBizFrom: '',
            keywords: '',
        };
        zoneList(param).then((res) => {
            if (res.constructor === Object) {
                this.filterArea = this.dealAreaTree([res]);
            }
            else {
                this.filterArea = this.dealAreaTree(res);
            }
        });
    }
    handleAreaChange(areaVal) {
        this.value = areaVal;
        this.$refs.queueReportCascader.dropDownVisible = false;
        this.$emit('handleAreaChange', this.value);
    }
    confirm() {
        this.$emit('CheckedKeys', this.value);
    }
    reset() {
        this.value = '';
        this.$emit('CheckedKeys', '');
    }
};
tableHeader = __decorate([
    Component({
        name: 'TabArea',
        components: {},
        i18n: {
            messages: {
                en: {
                    reset: 'Reset',
                    confirm: 'Confirm',
                    selectAreaPlaceholder: 'Please select a region',
                },
                zh: {
                    reset: '重置',
                    confirm: '筛选',
                    selectAreaPlaceholder: '请选择地区',
                },
            },
        },
    })
], tableHeader);
export default tableHeader;
